import * as React from 'react';



export default class Policies extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 22">
       <path d="M3 5H2C1.44772 5 1 5.44772 1 6V20C1 20.5523 1.44772 21 2 21H16.5C17.0523 21 17.5 20.5523 17.5 20V19.5" stroke="white" strokeWidth="1"/>
        <mask id="path-2-inside-1_2_168" fill="white">
        <rect x="4.5" width="18" height="18" rx="1"/>
        </mask>
        <rect x="4.5" width="18" height="18" rx="1" stroke="white" strokeWidth="1.5" mask="url(#path-2-inside-1_2_168)"/>
        <path d="M10.733 14V3.81818H14.1733C14.9721 3.81818 15.625 3.96236 16.1321 4.25071C16.6425 4.53575 17.0204 4.92188 17.2656 5.40909C17.5109 5.89631 17.6335 6.43987 17.6335 7.03977C17.6335 7.63968 17.5109 8.1849 17.2656 8.67543C17.0237 9.16596 16.6491 9.55705 16.142 9.84872C15.6349 10.1371 14.9853 10.2812 14.1932 10.2812H11.7273V9.1875H14.1534C14.7003 9.1875 15.1394 9.09304 15.4709 8.90412C15.8023 8.7152 16.0426 8.45999 16.1918 8.13849C16.3442 7.81368 16.4205 7.44744 16.4205 7.03977C16.4205 6.6321 16.3442 6.26752 16.1918 5.94602C16.0426 5.62453 15.8007 5.37263 15.4659 5.19034C15.1312 5.00473 14.687 4.91193 14.1335 4.91193H11.9659V14H10.733Z" fill="white" strokeWidth="0.5"/>
      </svg>
    )
  }
}
